module.exports = __webpack_public_path__ + "static/media/builtinv2-Иконка скорость.55f06a58.svg";